/**
 * DevExtreme (esm/__internal/grids/data_grid/module_not_extended/virtual_columns.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import { virtualColumnsModule } from "../../../grids/grid_core/virtual_columns/m_virtual_columns";
import gridCore from "../m_core";
gridCore.registerModule("virtualColumns", virtualColumnsModule);